<template>
    <p>
        <slot></slot>
    </p>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
p {
    font-family: 'Pretendard', sans-serif;
    font-size: 18px;
    color: var(--black2);
    letter-spacing: -0.025em;
    font-weight: 400;
    line-height: 1.6;

    @media screen and (max-width: 768px) {
        font-size: 16px;
    }
}
</style>
